import { INVALID_MSG, SUB_LEVEL_REGEX } from "./constants";
/**
 * Many Structured Events require a location that represents an entity's placement in AC3.
 * This function validates if a sublevel meets our standard. A sequence of sublevels
 * separated by forward slashes makes a full location
 *
 * @see https://console.harmony.a2z.com/aviary/develop/monitoring/publishing-to-cdp/#more-on-location-fields
 *
 * @param sublevel
 * @returns True if sublevel matches {@link SUB_LEVEL_REGEX}
 */
export function isSublevelValid(sublevel) {
    return SUB_LEVEL_REGEX.test(sublevel);
}
/**
 * Many Structured Events require a location that represents an entity's placement in AC3.
 * This function validates if a fullLocation meets our standard. A fullLocation
 * is a sequence of sublevels separated by forward slashes. The first sublevel must be ac3
 *
 * @see https://console.harmony.a2z.com/aviary/develop/monitoring/publishing-to-cdp/#more-on-location-fields
 *
 * @param fullLocation
 * @returns True if each sublevel passes {@link isSublevelValid}
 */
export function isFullLocationValid(fullLocation) {
    if (!fullLocation)
        return false;
    const parts = fullLocation.split('/');
    if (parts[0] !== 'ac3')
        return false;
    return parts.every(isSublevelValid);
}
/**
 * A simple way to convert a value to a string. It does not handle Objects, Arrays, nor Functions.
 * @param input
 * @returns A string of the input if it is a string, boolean, number, bigint, undefined, or null.
 * Otherwise, returns {@link INVALID_MSG.CANNOT_CONVERT_VALUE_TO_STRING}.
 */
export const convertToStringForStructuredEvents = (input) => {
    if (input === null)
        return 'null';
    const STRINGABLE_VALUES = [
        'string',
        'boolean',
        'number',
        'bigint',
        'undefined',
    ];
    if (STRINGABLE_VALUES.includes(typeof input)) {
        return String(input);
    }
    return INVALID_MSG.CANNOT_CONVERT_TO_STRING;
};
//# sourceMappingURL=utils.js.map